<template>
  <div
    class="slide-factory"
    :data-slide-id="slideData.id"
    :data-slide-type="resolvedSlideType"
  >
    <component
      :is="slideComponent"
      :key="slideData.id"
      :data="slideData.data"
      :slide-id="slideData.id"
    />
  </div>
</template>

<script>
import {
  getQuarterlySlideComponent,
  resolveQuarterlySlideType
} from './slideRegistry';

export default {
  name: 'QuarterlySlideFactory',
  props: {
    slideData: {
      type: Object,
      required: true,
      default: () => ({ id: 'empty', type: 'Empty', data: {} })
    }
  },
  computed: {
    resolvedSlideType() {
      return resolveQuarterlySlideType(this.slideData.type);
    },
    slideComponent() {
      return getQuarterlySlideComponent(this.slideData.type);
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-factory {
  width: 100%;
  height: 100%;
}
</style>
